import { MeasurementPlan } from '../types/protocol.js';


export const MANUAL_MEASUREMENT_VARIANTS = ['A', 'B', 'C'] as const;
export type ManualMeasurementVariant = typeof MANUAL_MEASUREMENT_VARIANTS[number];

export function getManualMeasurementVariants(
    measurementPlan: MeasurementPlan | undefined,
): ManualMeasurementVariant[] {
    return MANUAL_MEASUREMENT_VARIANTS.filter(variantName => {
        if (variantName === 'A') return true;

        const variant = measurementPlan?.variants?.find(it => it.name === variantName);
        return variant != null && Object.values(variant.positions).some(count => count > 0);
    });
}
